import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SITE, NAV } from "../lib/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-black text-white mt-24">
      <div className="container-soft py-20">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <p className="overline text-white/60">Pompes Funèbres</p>
            <h3 className="font-serif-display text-3xl mt-2">Lumière des Nations</h3>
            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
              {SITE.tagline} Un accompagnement humain, du premier appel jusqu'au dernier hommage.
            </p>
            <div className="hairline-white my-8" />
            <p className="overline text-white/60">{SITE.badge}</p>
          </div>

          <div>
            <p className="overline text-white/60">Navigation</p>
            <ul className="mt-4 space-y-2">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-nav-${n.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="overline text-white/60">Contact</p>
            <ul className="mt-4 space-y-3 text-sm text-white/80">
              <li className="flex items-start gap-3">
                <MapPin size={16} strokeWidth={1.5} className="mt-0.5 flex-none" />
                <span>{SITE.address}</span>
              </li>
              <li>
                <a
                  href={SITE.phoneHref}
                  data-testid="footer-call-link"
                  className="flex items-start gap-3 hover:text-white transition-colors"
                >
                  <Phone size={16} strokeWidth={1.5} className="mt-0.5 flex-none" />
                  <span>{SITE.phone}</span>
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} strokeWidth={1.5} className="mt-0.5 flex-none" />
                <a href={`mailto:${SITE.email}`} className="hover:text-white transition-colors break-all">
                  {SITE.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={16} strokeWidth={1.5} className="mt-0.5 flex-none" />
                <span>{SITE.availability}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="hairline-white my-12" />
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Pompes Funèbres Lumière des Nations. Tous droits réservés.</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/mentions-legales" data-testid="footer-mentions-link" className="hover:text-white transition-colors">
              Mentions légales
            </Link>
            <Link to="/confidentialite" data-testid="footer-confidentialite-link" className="hover:text-white transition-colors">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
